import { render } from "./UserAdmin.vue?vue&type=template&id=3d769922"
import script from "./UserAdmin.vue?vue&type=script&lang=js"
export * from "./UserAdmin.vue?vue&type=script&lang=js"

import "./UserAdmin.vue?vue&type=style&index=0&id=3d769922&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__